export default __webpack_public_path__ + "static/media/home-track-mobile-merge.c117df5f.svg";